import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {BaseGameMNS2} from "../base/BaseGameMNS2";

export class ADNEditor {

  constructor(el) {
    this.$el = $(el);

    this.initialClipZoneWidth = this.$el.find(".adn-clip-zone").width();
    this.nextStepCallback = null;
    this.currentTimeline = null;
    this.init();
  }

  init() {
    this.createSegmentsDraggables();
    this.scissors1 = this.createScissor(this.$el.find("#adn-left-scissors"));
    this.scissors2 = this.createScissor(this.$el.find("#adn-right-scissors"));
  }

  createSegmentsDraggables() {
    this.$draggablesADNs = this.$el.find(".adn.draggable");
    this.$dropZonesADN = this.$el.find(".adn-drop-zone-container");

    // This is old school `this` scope handling for 'snap' function
    const _this = this;

    this.$draggablesADNs.get().forEach((n) => {

      // Save initial positions
      const initialX = gsap.getProperty(n, "x");
      const initialY = gsap.getProperty(n, "y");
      $(n).data("initial-position", {x: initialX, y: initialY})

      // Pre-compute final positional offset
      const shadowOffset = {x: 23, y: 20};
      const finalX = (1080 / 2) - $(n).offset().left - ($(n).width() / 2) - shadowOffset.x / 2 + 4;
      const finalY = $(".middle-adn img").offset().top - $(n).offset().top - shadowOffset.y / 2 - 2;

      const $el = $(n)
      $el.on("mousedown touchstart", (e) => {
        if ($el.hasClass("is-dragging") === false) {
          $el.addClass("is-dragging");
          // _this.createDraggableClone(n, e.originalEvent);
          // _this.enableAvailableDropzones($el);
        }
      })

      const offset = {
        "left": $(n).data("offset-left"),
        "right": $(n).data("offset-right")
      };
      const segmentEnlargeTimeline = this.createSegmentTimeline($(n).width() - (shadowOffset.x * 2), offset.left, offset.right);

      const computeProgress = function (y) {
        return map(y, initialY, finalY, 0, 1);
      };
      const updateSegment = function (y) {
        const progress = computeProgress(y);
        // console.log(progress);
        segmentEnlargeTimeline.progress(progress);
      };

      // Start draggable
      const draggable = Draggable.create($el, {
        inertia: true,
        throwResistance: 5000,
        zIndexBoost: 98,
        bounds: {top: -this.$el.find(".adn-selector-container").offset().top, left: -20, width: 1080 + 20, height: 1920},
        onDragStart: (e) => {
          _this.$el.find(".adn-selector-container").addClass("is-dragging");
          _this.$el.find(".adn-drop-zone-container").addClass("is-dragging");
          app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXADNup.mp3", 1, true)
        },
        onMove: function () {
          updateSegment(this.y);
        },
        onThrowUpdate: function () {
          updateSegment(this.y);
        },
        snap: {
          y: function (endValue) {
            const progress = computeProgress(this.endY);
            // console.log("progressY", progress, this.endY);
            return (progress > 0.8) ? finalY : 0;
          },
          x: function (endValue) {
            const progress = computeProgress(this.endY);
            // console.log("progressX", progress, this.endY);
            return (progress > 0.8) ? finalX : 0;
          },
        },
        onThrowComplete: function (e) {
          Draggable.zIndex = 100;
          _this.$dropZonesADN.removeClass("is-dragging");

          // Now check if the adn has been dropped in the drop zone
          if (computeProgress(this.y)) {
            _this.nextStepCallback($(this.target).data("adn-id"));
            app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXADNdown.mp3", 1, true)
          } else {
            _this.$el.find(".adn-selector-container").removeClass("is-dragging");
          }

          $(this.target).removeClass("is-dragging");
        },
      })[0];

      // Disable by default
      draggable.disable()

      // Save draggable reference into DOM object data
      $(n).data("draggable", draggable)

    })

    Draggable.zIndex = 5;
  }

  createScissor($el) {
    const scissorSize = $el.find(".scissor-handle").height();
    const $scissorFill = $el.find(".scissor-fill");

    const updateFill = function (progress) {
      gsap.set($scissorFill, {scaleY: progress, transformOrigin: "top center"})
    };

    // This is old school `this` scope handling for 'snap' function
    const _this = this;

    return Draggable.create($el.find(".scissor-handle"), {
      type: 'y',
      inertia: true,
      edgeResistance: 0.99,
      overshootTolerance: 0,
      bounds: {minX: scissorSize / 2, maxX: scissorSize / 2, minY: 0, maxY: $el.height()},
      onDragStart: function () {
        // Stop pulse
        $(this.target).removeClass("pulse");
        // TODO Hide handcoach here
      },
      onMove: function () {
        const progress = map(this.y, this.minY, this.maxY, 0, 1);
        updateFill(progress);
      },
      onThrowUpdate: function () {
        const progress = map(this.y, this.minY, this.maxY, 0, 1);
        updateFill(progress);
      },
      onThrowComplete: function () {
        const progress = map(this.y, this.minY, this.maxY, 0, 1);
        if (progress > 0.99) {
          this.disable();
          $el.addClass("completed");
          gsap.to(this.target, {
            scale: 0,
            ease: "back.in(2)",
            duration: 0.35,
          })

          app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXciseaux.mp3", 1, true)

          // Swipe out cut segment if both scissor are completed
          if (_this.allScissorCompleted()) _this.swipeOutSegment()

        } else {
          // Pulse scissor handle
          _this.$el.find(this.target).addClass("pulse");
        }
      },
      snap: function (endValue) {
        return Math.round(endValue / $el.height()) * $el.height();
      },
    })[0];
  }

  createSegmentTimeline(width, leftOffset = 0, rightOffset = 0) {
    const scaleTarget = width / this.initialClipZoneWidth
    const openingWidth = width - this.initialClipZoneWidth
    const tl = gsap.timeline({paused: true});
    tl.fromTo(this.$el.find(".adn-clip-zone"), {scaleX: 1}, {scaleX: scaleTarget, duration: 1}, 0)
    tl.fromTo(this.$el.find(".adn-clip-zone"), {autoAlpha: 1}, {autoAlpha: 1, duration: 0.35, immediateRender: false}, 0)
    tl.fromTo(this.$el.find(".left-adn"), {x: 0}, {x: -openingWidth / 2 - leftOffset, duration: 1}, 0)
    tl.fromTo(this.$el.find("#adn-left-scissors"), {x: 0}, {x: -openingWidth / 2 , duration: 1}, 0)
    tl.fromTo(this.$el.find(".right-adn"), {x: 0}, {x: openingWidth / 2 - rightOffset, duration: 1}, 0)
    tl.fromTo(this.$el.find("#adn-right-scissors"), {x: 0}, {x: openingWidth / 2, duration: 1}, 0)
    return tl;
  }

  swipeOutSegment() {
    this.currentTimeline = gsap.timeline();
    this.currentTimeline.to(this.$el.find(".adn-part.middle-adn"), {
      scale: 0.85,
      y: "+=50",
      // ease: "back.in(1)",
      ease: "sine.out",
      duration: 0.5,
    }, "+=0.4")
    this.currentTimeline.to(this.$el.find(".adn-part.middle-adn"), {
      opacity: 0,
      ease: "sine.in",
      duration: 0.25,
    }, "-=0.25")
    this.currentTimeline.to(this.$el.find(".adn-clip-zone"), {
      alpha: 0,
      ease: "sine.out",
      duration: 0.5,
    }, "<")

    // Enable segment drag
    this.currentTimeline.add(() => {
      this.$el.find(".adn-selector-container").removeClass("disabled");
      this.$el.find(".adn-drop-zone-container").addClass("segment-mode");
      for (const adnEl of this.$draggablesADNs.get()) {
        $(adnEl).data("draggable").enable()
      }
    })
  }

  allScissorCompleted() {
    return $(this.scissors1.target).parents(".adn-scissor").hasClass("completed") && $(this.scissors2.target).parents(".adn-scissor").hasClass("completed");
  }

  resetDraggable(el) {
    const initialPosition = $(el).data("initial-position");
    $(el).data("draggable").disable();

    gsap.to(el, {
      x: initialPosition.x,
      y: initialPosition.y,
      duration: 0.5,
      ease: 'sine.out',
    })
  }

  reset() {

    BaseGameMNS2.killTimeline(this.currentTimeline);

    // Reset all ADN segments draggables
    for (const adnEl of this.$draggablesADNs.get()) {
      this.resetDraggable(adnEl)
    }

    // Disable top by default
    this.$el.find(".adn-selector-container").addClass("disabled");
    this.$el.find(".adn-drop-zone-container").removeClass("segment-mode");
    this.$el.find(".scissor-handle").removeClass("pulse").first().addClass("pulse");

    // Reset all scissors segments draggables
    this.$el.find(".adn-scissor").removeClass("completed");
    for (const scissorDraggable of [this.scissors1, this.scissors2]) {
      scissorDraggable.enable();
      gsap.set(scissorDraggable.target, {y: 0, scale: 1})
      gsap.set($(scissorDraggable.target).siblings(".scissor-fill"), {scaleY: 0})
    }
    gsap.set(this.$el.find(".adn-part.left-adn, #adn-left-scissors"), {x: 0, scale: 1})
    gsap.set(this.$el.find(".adn-part.right-adn, #adn-right-scissors"), {x: 0, scale: 1})
    gsap.set(this.$el.find(".adn-part.middle-adn, .adn-scissors"), {autoAlpha: 1, y: 0, scale: 1})
    gsap.set(this.$el.find(".adn-clip-zone"), {autoAlpha: 1, scaleX: 1})
  }

}
